import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface CommunitySegmentExecutePreviewProps {
  people_count?: number;
  title?: string;
}

export const CommunitySegmentExecutePreview = ({
  title,
  people_count,
}: CommunitySegmentExecutePreviewProps) => {
  const peopleText =
    people_count != null
      ? t("help_widget.copilot.execute_preview.people_count", {
          count: people_count,
        })
      : undefined;

  return (
    <ExecutePreviewCard
      title={t("help_widget.copilot.execute_preview.segment_title")}
      attributes={[
        {
          label: t("help_widget.copilot.execute_preview.name"),
          value: title,
        },
        {
          label: t("help_widget.copilot.execute_preview.people"),
          value: peopleText,
        },
      ]}
    />
  );
};
